<template>
  <DialogComponent
    hashBase="bottomsheet"
    ref="dialog"
    :onOpening="onOpening"
    :onOpened="
      () => {
        isOpened = true
        onOpened && onOpened()
      }
    "
    :onClosing="onClosing"
    :onClosed="
      () => {
        isOpened = false
        onClosed && onClosed()
      }
    "
    :onBackButtonClick="onBackButtonClick"
  >
    <div
      class="bottomDialogContainer overHeader layoutPosition overflow-hidden z-[10]"
      :class="{ visible: isOpened }"
    >
      <!-- Overlay -->
      <div
        @click="
          () => {
            if (onOverlayClick) onOverlayClick()
            else if (overlayerCanDismiss) hide()
          }
        "
        class="overlay !duration-[0.1s]"
      ></div>

      <!-- Dialog -->
      <div
        class="bottomDialog duration-[0.4s] ease-in-out"
        :style="{ '--handleColor': handleColor }"
      >
        <div class="bg-white absolute w-full h-full z-[0]"></div>

        <div class="py-2"></div>
        <div class="swipeWatcher"></div>
        <!-- <div class="py-1"></div> -->

        <div class="relative">
          <div
            class="longAndScrollableContentContainer max-h-[80svh] overflow-auto"
            v-if="keepContentAlive ? true : contentIsVisible"
          >
            <slot></slot>
            <!-- <div class="h-screen"></div>
            <div class="">ddf</div> -->
          </div>
        </div>
      </div>
    </div>
  </DialogComponent>
</template>

<script>
import { defineComponent } from 'vue'
import DialogComponent from './DialogComponent.vue'

export default defineComponent({
  name: 'BottomSheetComponent',
  components: { DialogComponent },
  props: {
    onOpening: { type: Function, default: () => {} },
    onClosing: { type: Function, default: () => {} },
    onOpened: { type: Function, default: () => {} },
    onClosed: { type: Function, default: () => {} },
    onBackButtonClick: { type: Function, default: null },

    onPrimaryClick: {
      type: Function,
      default: () => {},
    },
    onOverlayClick: {
      type: Function,
      default: null,
    },
    onCancelClick: {
      type: Function,
      default: null,
    },
    overlayerCanDismiss: {
      type: Boolean,
      default: true,
    },
    buttonsToRight: {
      type: Boolean,
      default: true,
    },
    primaryButtonLoading: {
      type: Boolean,
      default: false,
    },
    keepContentAlive: {
      type: Boolean,
      default: false,
    },
    hashBase: {
      type: String,
      default: 'bottomsheet',
    },

    headerBg: {
      type: String,
      default: '#e7ecfd',
    },
    handleColor: {
      type: String,
      default: '#c9c7e1',
    },
  },

  data() {
    return {
      isOpened: false,
      contentIsVisible: false,
      updateVisibilityTimeout: 0,
    }
  },

  methods: {
    show() {
      this.$refs.dialog.show()
    },
    hide() {
      this.$refs.dialog.hide()
    },
    isVisible() {
      return this.$refs.dialog.isVisible()
    },
  },

  watch: {
    isOpened(newVal) {
      clearTimeout(this.updateVisibilityTimeout)
      if (newVal) {
        this.contentIsVisible = true
      } else if (!this.keepContentAlive) {
        this.updateVisibilityTimeout = setTimeout(() => {
          this.contentIsVisible = false
        }, 500)
      }
    },
  },
})
</script>

<style scoped>
.layoutPosition {
  max-width: 100% !important;
  left: calc(50% - min(100%, 100%) / 2) !important;
  position: fixed !important;
  width: 100% !important;
}

/*
BOTTOM DIALOG
*/
.bottomDialogContainer {
  position: fixed;
  top: 100%;
  left: 0;
  width: 100%;
  height: 100%;
  transition-duration: 0s !important;
  transition-delay: 700ms !important;
}

.bottomDialogContainer.visible {
  display: block;
  top: 0%;
  transition-delay: 0ms !important;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0;
}

.bottomDialogContainer.visible .overlay {
  opacity: 0.3;
}

.bottomDialog {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  /* background-color: white; */
  border-radius: 15px 15px 0 0 !important;
  overflow: hidden;
}

.dialogHeader {
  width: 100%;
  left: 0;
  /* background-color: #e7ecfd; */
  border-radius: 15px 15px 0 0;
  padding-top: 20px;
}

.swipeWatcher {
  width: 90px;
  height: 30px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  top: 0px;
  cursor: cell;
}

.swipeWatcher:after {
  content: '';
  width: 80%;
  height: 7px;
  border-radius: 4px;
  background-color: rgba(200, 200, 200, 0.7);
  background-color: #c9c7e1;
  background-color: var(--handleColor);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.bottomDialog .longAndScrollableContentContainer {
}

.bottomDialogContainer:not(.visible) .bottomDialog {
  transform: translateY(100%) !important;
  opacity: 0;
}
</style>
